import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import CardSimple from 'screens/components/basic/CardSimple';
import Body from './Body';
import Header from './Header';
import { getUncountedReport, getCsvReport } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import Pagination from 'screens/components/basic/Pagination';
import reportsUtil from 'utils/reportsApi';
import Grid from 'screens/components/basic/Grid';
import { reportUncountedReport } from 'utils/breadcrumbInfo';
import PageHeader from 'screens/components/basic/PageHeader';
import { showError } from 'actions/CommonActions';
import { checkDateRange } from 'utils/helpers';
import WithRouter from 'custom/withRouter';

class UncountedReport extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            showBody: false,
            totalRow: 0
        };
        this.showBody = this.showBody.bind(this)
    }

    componentWillMount() {
        const date = new Date()
        this.props.formInput(new Date(date.getFullYear(), date.getMonth(), 1),
            `UncountedReportBeginDate`);
        this.props.formInput(date, `UncountedReportEndDate`);
        if (localStorage.getItem("UncountedReportBranchIds") != null) {
            this.props.formInput(localStorage.getItem("UncountedReportBranchIds").split(","), "UncountedReportBranchIds")
        }

    }

    componentDidUpdate(prevProps) {
        if (this.props.selectedBranchIds != undefined && this.props.selectedBranchIds != prevProps.selectedBranchIds) {
            localStorage.setItem("UncountedReportBranchIds", this.props.selectedBranchIds)
        }
    }

    componentWillReceiveProps = (newProps) => {
        if (this.state.showBody) {
            const totalRow = newProps.uncountedReport && newProps.uncountedReport.length > 0 ? newProps.uncountedReport[0].totalRows : 0;
            this.setState({ totalRow: totalRow });
        }
    }

    cleanSearch = () => {
        this.props.clearFormInput(`UncountedReportBeginDate`);
        this.props.clearFormInput(`UncountedReportEndDate`);

        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    downloadReport = () => {
        let selectedDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branchIds = this.props.selectedBranchIds.join(",");
        let numberOfDays = this.props.numberOfDays || 365;

        this.props.getCsvReport(`reports/excel/uncountedreport?selectedDate=${selectedDate}&branchIds=${branchIds}&numberOfDays=${numberOfDays}`, "uncountedReport");

    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    getReport = () => {
        let selectedDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branchIds = this.props.selectedBranchIds ? this.props.selectedBranchIds.join(",") : '';
        let numberOfDays = this.props.numberOfDays || 365;
        let pageNumber = this.state.activePage;
        let pageSize = this.state.itemsPerPage;
        this.props.getUncountedReport({ selectedDate, branchIds, numberOfDays, pageNumber, pageSize });
    }

    showBody() {
        this.filter();
        this.setState({ showBody: true });
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }


    render() {
        return (
            <Grid headerContent={reportUncountedReport}>
                <PageHeader title={LOOKUP.report.UncountedReport.text} 
                    description={LOOKUP.report.UncountedReport.description}
                />
                <Header
                    filter={this.filter}
                    download={this.downloadReport}
                    showBody={this.showBody}
                    branchOptions={this.props.branchOptions}
                />
                {
                    this.state.showBody &&
                    <p className="text-right mt-2 blue-text">
                        <i>Generated on : {moment().format('MMMM Do YYYY, h:mm:ss a')}</i>
                    </p>
                }
                {
                    this.state.showBody && this.props.uncountedReport &&
                    <CardSimple>
                        <Body
                            uncountedReport={this.props.uncountedReport}
                            beginDate={this.props.beginDate}
                            endDate={this.props.endDate}
                        />
                        <Pagination
                            length={this.state.totalRow}
                            itemsPerPage={this.state.itemsPerPage}
                            activePage={this.state.activePage}
                            onPageChange={this.changePage}
                        />
                    </CardSimple>
                }
            </Grid>
        );
    }

}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let branchOptions = [];
    branches.map((item) => {
        branchOptions.push({
            text: item.name, value: item.id.toString()
        });
    })

    return {
        branchOptions: branchOptions,
        uncountedReport: state.reports.uncountedReport,
        loggedBranch: state.common.branchId,
        endDate: state.form.UncountedReportEndDate,
        selectedBranchIds: state.form.UncountedReportBranchIds,
        numberOfDays: state.form.UncountedReportNumberOfDays
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getUncountedReport: model => dispatch(getUncountedReport(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        showError: (message) => dispatch(showError(message)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(UncountedReport));